import React from 'react';
import { PLAN_BENEFITS } from '../../data/welding';

/** Compact problem → plan bridge between the preview and the technical proof. */
export function PlanSection() {
  return <section aria-labelledby="plan-title" className="bg-surface py-14 sm:py-20" data-id="element-220" data-mp="16x2jarix2t8r">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:items-end lg:gap-14" data-id="element-221" data-mp="16v9cnc8b090r">
        <div className="lg:col-span-6" data-id="element-222" data-mp="f5wie8vdgrif">
          <h2 id="plan-title" className="font-heading text-[2.05rem] font-bold uppercase leading-[0.98] text-white min-[390px]:text-[2.25rem] sm:text-[2.8rem] lg:text-[3.1rem]" data-id="element-223" data-mp="f6xrw8wqp5y1">
            YOU KNOW HOW TO WELD. START WITH A CLEAR PLAN.
          </h2>
          <p className="mt-4 max-w-xl text-[1rem] leading-relaxed text-steel-pale sm:text-[1.08rem]" data-id="element-224" data-mp="sxkq7zyl8ttl">
            The fabrication is your skill. The collection gives you a practical starting point for planning the build:
            dimensions, steel parts, cutting information, technical views, and an assembly sequence.
          </p>
        </div>

        <ol className="grid gap-0 sm:grid-cols-3 sm:border-t sm:border-arc/40 lg:col-span-6" data-id="element-225" data-mp="212739m0hho0j">
          {PLAN_BENEFITS.map(benefit => <li key={benefit} className="relative border-l border-arc/40 py-3 pl-5 sm:border-l-0 sm:pl-0 sm:pr-5 sm:pt-6" data-id="element-226" data-mp="1s79colkt6ncd">
              <span className="absolute -left-[5px] top-[18px] h-[9px] w-[9px] rotate-45 border border-arc bg-surface sm:-top-[5px] sm:left-0" aria-hidden data-id="element-227" data-mp="1n6vahk5w27m9" />
              <p className="font-heading text-[1.3rem] font-semibold uppercase leading-tight text-white" data-id="element-228" data-mp="1dcuw0ropvq0v">{benefit}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}